import React, { useState, useEffect, ChangeEvent } from 'react';
import { Breadcrumbs, Typography, TableCell, TableRow, } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AddButton from '../../components/Button/AddButton';
import TableComponent from '../../components/Table/TableComponent';
import TablePaginationComponent from '../../components/Table/TablePaginationComponent';
import ActionButtons from '../../components/Button/ActionButtons';
import { ApiResponse, allergyMasters } from './masterinterface';
import { deleteRequest, getRequest } from './baseservice';
import LoadingAnimation from '../../components/LoadingAnimation';

import ConfirmationDialog from '../../components/Dialog/ConfirmationDialog';
import LabMasterDialog from './Master Dialog/labdialog';


const Lab: React.FC = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [allergies, setAllergies] = useState<allergyMasters[]>([]);
  const [totalAllergies, setTotalAllergies] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const location = useLocation();
  const [selectedAllergy, setSelectedAllergy] = useState<allergyMasters | null>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteAllergyId, setDeleteAllergyId] = useState<number | null>(null);

  const { providerId, userid } = location.state || {};

  const fetchAllergies = async () => {
    setLoading(true);
    try {
      const response = await getRequest<ApiResponse>('resource/custom_masters', {
        limit: rowsPerPage,
        page: page + 1,
        slug: 'lab',
        order_by: 'name',
        dir: 1,
        user_id: userid,
      });

      const data = response.data;
      setAllergies(data.custom_masters);
      setTotalAllergies(data.pagination.total);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch allergies');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllergies();
  }, [page, rowsPerPage]);

  const handleBack = () => navigate(-1);
  const handleClickOpen = () => setOpenDialog(true);
  const handleClose = () => {
    setOpenDialog(false);  // Close the dialog
    fetchAllergies();  // Fetch the updated allergies data after closing
  };
  const handleSave = () => {
    setOpenDialog(false);  // Close the dialog
    fetchAllergies();  // Fetch the updated allergies data after saving
  };

  const handleDelete = async () => {
    if (deleteAllergyId) {
      try {
        await deleteRequest<ApiResponse>(`resource/custom_masters/${deleteAllergyId}`);
        setConfirmDelete(false);
        fetchAllergies(); // Refresh allergy data after deletion
      } catch (err) {
        setError('Failed to delete allergy');
      }
    }
  };


  const renderRow = (row: allergyMasters, index: number) => (
    <TableRow key={row.id}>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}> {page * rowsPerPage + index + 1}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>{row.name}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>{row.slug}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>
        <ActionButtons
          onEdit={() => {
            setSelectedAllergy(row);  // Set the selected allergy
            setOpenDialog(true);       // Open the dialog
          }}
          onDelete={() => {
            setDeleteAllergyId(row.id); // Set the selected allergy ID to delete
            setConfirmDelete(true); // Show the confirmation dialog
          }}

        />
      </TableCell>
    </TableRow>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
      <div className="flex justify-between items-center w-full mt-20">
        <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 3 }}>
          <Typography color="primary" onClick={handleBack} style={{ cursor: 'pointer' }}>
            Back
          </Typography>
          <Typography color="primary" fontWeight="bold">
          Lab Masters
          </Typography>
        </Breadcrumbs>
        <AddButton text="Add" onClick={handleClickOpen} />
      </div>

      {loading ? (
        <LoadingAnimation />
      ) : (
        <>
          <TableComponent
            headers={['S.No', 'Name', 'Code', 'Actions']}
            data={allergies}
            renderRow={renderRow}
            loading={loading}
            error={error}
          />
          <TablePaginationComponent
            count={totalAllergies}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(_event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              const newRowsPerPage = parseInt(event.target.value, 10);
              setRowsPerPage(newRowsPerPage);
              setPage(0);
            }}
          />
        </>
      )}

      <LabMasterDialog
        open={openDialog}
        onClose={handleClose}
        onSave={handleSave}
        providerid={providerId}
        selectedAllergy={selectedAllergy} />

      <ConfirmationDialog
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onConfirm={handleDelete}
        title="Are you sure you want to delete?"
      />
    </div>
  );
};

export default Lab;
